import { render, staticRenderFns } from "./FormsSetting.vue?vue&type=template&id=7b0f55ba&scoped=true"
import script from "./FormsSetting.vue?vue&type=script&lang=js"
export * from "./FormsSetting.vue?vue&type=script&lang=js"
import style0 from "./FormsSetting.vue?vue&type=style&index=0&id=7b0f55ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0f55ba",
  null
  
)

export default component.exports